<script setup lang="ts">
import { InputGroup, ColorPicker, InputGroupAddon, InputText } from 'primevue';
import { useTranslations } from '../../translations/composables/useTranslations';
import { computed, ref, watch } from 'vue';
import { useElementId } from '../../common/composables/useElementId';

const props = defineProps<{
  title?: string,
  changed: boolean
}>();

const modelValue = defineModel<string|null|undefined>({ required: true });
const translations = useTranslations();
const title = computed(() => props.title ?? translations.value.generic.color);
const elementId = useElementId();

const internalValue = ref<string|null>();
updateInternalValue();

watch(modelValue, (v) => {
  updateInternalValue();
});

watch(internalValue, (v) => {
  updateModelValue();
});

function updateInternalValue() {
  const value = modelValue.value;

  if (value) {
    internalValue.value = value.replace("#", "");
  } else {
    internalValue.value = value;
  }
}

function updateModelValue() {
  const value = internalValue.value;

  if (value) {
    modelValue.value = `#${value}`;
  } else {
    modelValue.value = value;
  }
}

</script>

<template>
  <div class="field" :class="{ changed: props.changed }">
    <label :for="elementId">{{ title }}</label>
    <InputGroup>
      <InputGroupAddon><ColorPicker v-model:model-value="internalValue" default-color="3b82f6" format="hex"></ColorPicker></InputGroupAddon>
      <InputText autocomplete="off" :id="elementId" v-model:model-value="internalValue"></InputText>
    </InputGroup>
  </div>
</template>
